import { lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import PrivateRoute from './pages/users/partials/auth/privateRoute';

const EmptyLayout = lazy(() => import('./layouts/empty'));
const Layout = lazy(() => import('./layouts/layout'));
const UsersIndex = lazy(() => import('./pages/users'));
const DashboardIndex = lazy(() => import('./pages/dashboard'));
const ErrorsIndex = lazy(() => import('./pages/errors'));
const ContactsIndex = lazy(() => import('./pages/contacts'));
const ContactsDetail = lazy(() => import('./pages/contacts/details'));
const ContactsNew = lazy(() => import('./pages/contacts/new'));
const MarketingIndex = lazy(() => import('./pages/marketing'));
const MarketingNew = lazy(() => import('./pages/marketing/new'));
const AnalyticsIndex = lazy(() => import('./pages/analytics'));
const VouchersIndex = lazy(() => import('./pages/vouchers'));
const IntegrationsIndex = lazy(() => import('./pages/integrations'));
const SettingsIndex = lazy(() => import('./pages/settings'));

function App() {
  // const evRoute = (path: string, element:JSX.Element, as?: string, layoutElement?:JSX.Element) => {
  //   const layout = layoutElement || <Layout />;
  //   return (
  //     <Route path={path} element={<PrivateRoute as={as} />}>
  //       <Route element={layout}>
  //         <Route index element={element} />
  //       </Route>
  //     </Route>
  //   );
  // }

  return (
    <BrowserRouter>
      <Routes>
        <Route path={`${process.env.PUBLIC_URL}/users`} element={<EmptyLayout />}>
          <Route index element={<UsersIndex />} />
          <Route path='xyz' element={<UsersIndex />} />
          <Route path='forgot' element={<UsersIndex />} />
          <Route path='login' element={<UsersIndex />} />
          <Route path='verify' element={<UsersIndex />} />
        </Route>

        <Route path={`${process.env.PUBLIC_URL}/`} element={<PrivateRoute />}>
          <Route element={<Layout />}>
            <Route index element={<DashboardIndex />} />
          </Route>
        </Route>
        <Route path={`${process.env.PUBLIC_URL}/contacts`} element={<PrivateRoute as='chats' />}>
          <Route element={<Layout />}>
            <Route path=':id' element={<ContactsDetail />} />
            <Route path='new' element={<ContactsNew />} />
            <Route path='segment' element={<ContactsIndex sections='segment' />} />
            <Route path='attributes' element={<ContactsIndex sections='attributes' />} />
            <Route index element={<ContactsIndex />} />
          </Route>
        </Route>
        <Route path={`${process.env.PUBLIC_URL}/marketing`} element={<PrivateRoute as='chats' />}>
          <Route element={<Layout />}>
            <Route path='whatsappCampaigns'>
              <Route path='new' element={<MarketingNew sections='campaign' />} />
              <Route index element={<MarketingIndex sections='campaign' />} />
            </Route>
            <Route path='whatsappTemplates' element={<MarketingIndex sections='template' />} />
            <Route path='emailCampaigns' element={<MarketingIndex sections='emailCampaign' />} />
            <Route path='emailTemplates' element={<MarketingIndex sections='emailTemplate' />} />
            <Route path='automations' element={<MarketingIndex sections='automation' />} />
          </Route>
        </Route>
        <Route path={`${process.env.PUBLIC_URL}/analytics`} element={<PrivateRoute />}>
          <Route element={<Layout />}>
            <Route index element={<AnalyticsIndex />} />
          </Route>
        </Route>
        <Route path={`${process.env.PUBLIC_URL}/vouchers`} element={<PrivateRoute />}>
          <Route element={<Layout />}>
            <Route index element={<VouchersIndex />} />
          </Route>
        </Route>
        <Route path={`${process.env.PUBLIC_URL}/integrations`} element={<PrivateRoute />}>
          <Route element={<Layout />}>
            <Route index element={<IntegrationsIndex />} />
          </Route>
        </Route>
        <Route path={`${process.env.PUBLIC_URL}/settings`} element={<PrivateRoute as='chats' />}>
          <Route element={<Layout />}>
            <Route index element={<SettingsIndex />} />
          </Route>
        </Route>
        <Route path='*' element={<ErrorsIndex section='not-found' />} />
        <Route path={`${process.env.PUBLIC_URL}/restricted`} element={<ErrorsIndex section='restricted' />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
